import Link from 'next/link'
import clsx from 'clsx'
import { useUser } from 'web/hooks/use-user'
import { ENV } from 'common/envs/constants'

// Axel Logo Icon - A simple "A" with prediction market styling
function AxelLogoIcon(props: { className?: string }) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      {/* Background circle */}
      <circle cx="20" cy="20" r="18" fill="url(#axel-gradient)" />
      {/* Letter A */}
      <path
        d="M20 8L10 32H14L16 26H24L26 32H30L20 8ZM17.5 22L20 14L22.5 22H17.5Z"
        fill="white"
      />
      {/* Chart line accent */}
      <path
        d="M12 20L16 17L20 19L24 15L28 18"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.6"
      />
      <defs>
        <linearGradient
          id="axel-gradient"
          x1="2"
          y1="2"
          x2="38"
          y2="38"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B82F6" />
          <stop offset="1" stopColor="#1D4ED8" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function ManifoldLogo(props: { className?: string; twoLine?: boolean }) {
  const { className } = props
  const user = useUser()

  return (
    <div className="flex items-center gap-2">
      <Link
        href={user ? '/home' : '/'}
        className={clsx(
          'group flex w-full flex-row items-center gap-2 px-1 outline-none',
          className
        )}
      >
        <AxelLogoIcon className="h-9 w-9 shrink-0 transition-transform group-hover:scale-105" />
        <div
          className={clsx(
            'text-xl font-semibold tracking-tight text-primary-600 dark:text-white'
          )}
        >
          {ENV == 'DEV' ? 'PREDITA DEV' : 'PREDITA'}
        </div>
      </Link>
    </div>
  )
}

// Export alias for backwards compatibility
export const AxelLogo = ManifoldLogo
